import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LinkDrive {
    message: any,
    isLoading: boolean;
    error: string | null;
}

const initialState: LinkDrive = {
    message: null,
    isLoading: false,
    error: null,
};


const linkGoogleDriveSlice = createSlice({
    name: "linkdrive",
    initialState,
    reducers: {
        linkGoogleDrive: (state: LinkDrive, action: PayloadAction<LinkDrive>) => {
            state.message = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: LinkDrive, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: LinkDrive, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetlinkGoogleDrive: () => initialState,

    },
});

export const {
    linkGoogleDrive,
    setloading,
    seterror,
    resetlinkGoogleDrive,
} = linkGoogleDriveSlice.actions;

export default linkGoogleDriveSlice.reducer;